import { Spinner } from "react-activity";
import "react-activity/dist/library.css";

const Loader = () => (
    <div className='activity-indicator-container'>
        <Spinner />
    </div>
)

export default Loader;